// shellPreview — the opt-in switch for the shared-shell review pass.
//
// Aaron, 2026-09-30: one visual shell and a persistent Janet across the OS,
// shown first on two reference screens (the main dashboard and Deals) before
// it extends to the other modules. It is now the default (see below).
import { useLocation } from 'react-router-dom'

const KEY = 'ns.shellPreview'

// 2026-10-01 (Aaron: "merge now"): the Bridge shell is the OS for everyone.
// `?shell=off` still returns this browser session to the previous layout (a
// rollback hatch, remembered for the session); `?shell=preview` or `?shell=on`
// clears it.
export function readShellPreview(search) {
  let param = null
  try { param = new URLSearchParams(search || '').get('shell') } catch { /* no URL */ }
  try {
    if (param === 'off') sessionStorage.setItem(KEY, '0')
    else if (param === 'preview' || param === 'on') sessionStorage.removeItem(KEY)
    return sessionStorage.getItem(KEY) !== '0'
  } catch {
    // Storage unavailable (private window, blocked site data): the URL alone decides.
    return param !== 'off'
  }
}

export default function useShellPreview() {
  const { search } = useLocation()
  return readShellPreview(search)
}
